module.exports = __webpack_public_path__ + "static/img/83077A_2_R_20200318_LC.8586e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/83077A_2_R_20200318_LC.png
// module id = YX9j
// module chunks = 0